import React, { useContext } from "react";
import useIsLiveSection from "./useIsLiveSection";
import { getLabel } from "../data/labels";
import { urls } from "..";
import { removeMultipleSlashes } from "../data/sport-utils";
import { XRouterNavigateContext } from "./seo/xrouter/XRouterNavigateContext";

export default function SectionSwitcherButton() {
    const isLiveSection = useIsLiveSection();
    const xrouterNavigateContext = useContext(XRouterNavigateContext);

    let type = null, url = null, label = null;
    if (isLiveSection) {
        type = 'prematch';
        url = removeMultipleSlashes(`${urls.base}/${urls.prematch.base}`);
        label = getLabel('menu.prematch');
    } else {
        type = 'live';
        url = removeMultipleSlashes(`${urls.base}/${urls.live.base}`);
        label = getLabel('menu.live');
    }

    return (
        <div className="xs-section-switcher" data-type={type} onClick={() => xrouterNavigateContext.navigate(url)}>
            <div class="img"></div>
            <div class="text">{label}</div>
        </div>
    );
}
